import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoIos = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22.406 7.737c.879-1.066 1.499-2.522 1.499-3.992a3.3 3.3 0 0 0-.044-.562c-1.441.057-3.17.95-4.194 2.162-.822.922-1.571 2.392-1.571 3.863 0 .23.043.446.058.518.086.015.23.044.389.044 1.283 0 2.897-.865 3.863-2.033m1.009 2.335c-2.148 0-3.907 1.312-5.03 1.312-1.197 0-2.754-1.225-4.628-1.225-3.56 0-7.163 2.94-7.163 8.475 0 3.46 1.326 7.106 2.983 9.456 1.413 1.989 2.653 3.617 4.44 3.617 1.758 0 2.537-1.167 4.727-1.167 2.22 0 2.725 1.139 4.67 1.139 1.932 0 3.215-1.773 4.44-3.517 1.355-2.004 1.931-3.95 1.946-4.05-.116-.03-3.805-1.543-3.805-5.766 0-3.661 2.897-5.304 3.07-5.434-1.917-2.753-4.843-2.84-5.65-2.84"
	})
});
export default SvgIcoIos;
